export const HIDE_ALERT = '[ALERT] HIDE_ALERT';
export const SHOW_ALERT = '[ALERT] SHOW_ALERT';
